<section class="petPrescription" id="homeHero">
  <div class="prescriptionRow bestPriceRow" id="bestPriceRowId">
    <div class="petRxHacker">

      <h2 class="get-up">Get up to 80% off + Cashback on Your Prescriptions</h2>
      
      <p class="use mb-0">Use the free NuLifeSpan Rx discount card to save and earn cashback rewards on prescription drugs at your local pharmacy</p>
      <p class="use note">The NuLifeSpan Rx prescription discount program is free. This is not insurance.</p>
      <div class="nav-adjust home">        
        <app-search></app-search>        
      </div>
      <!-- <button class="" (click)="newDiscountModal()">Get Your Free Card Now</button> -->
      <!-- <a data-scrollspy-listen="homeNavSearch" ng-click="scrollTo('homeNavSearch')" href="">Get Your Free Card Now</a> -->
    </div>
    <img src="../../assets/images/home_hero.png">
  </div>
  <!-- <img src="../../assets/images/arrowHero.png" class="arrowHero"> -->
   <img src="../../assets/images/seperator.svg" class="hero-seperator" />
</section>
<!-- <section class="tab-section">
  <ul>
    <li *ngFor="let pharmacy of distinctpharmacy">
      <img src={{pharmacy.phlogo}} alt="" data-title={{pharmacy.phname}}>
    </li>
  </ul>
  <p>Your location <b>New Delhi, India 208017 </b><a href="#">Change</a></p>
</section> -->

<div class="skeltonloade" *ngIf="!carouselloaded">
  <div class="logobox">
    <div class="box"></div>
    <div class="box"></div>
    <div class="box"></div>
    <div class="box"></div>
    <div class="box"></div>
  </div>
  <div class="slideboxparent">
    <div class="box"></div>
    <div class="box"></div>
    <div class="box"></div>
  </div>
</div>
<div class="comparePrices">
  <p>Compare prices at over 35,000 pharmacies</p>
</div>
<section class="tab-section" *ngIf="carouselloaded">
  <ul>
    <li *ngFor="let pharmacy of distinctpharmacy" (click)="selectPharmacy(pharmacy.phname)" [class.active]="pharmacy.phname === selectedPharmacy">
      <img
        src="{{ pharmacy.phlogo }}"
        alt=""
        data-title="{{ pharmacy.phname }}"
        
      >
    </li>
  </ul>
  <p>Your location <b>{{this._CurrLocation}} </b> <a href="javascript:;" (click)="openzipbox()">Change</a></p>
</section>
<section class="carousel-section" *ngIf="carouselloaded">
 <ngx-slick-carousel class="review" #slickModal="slick-carousel" [config]="coupenConfig">
    <div ngxSlickItem *ngFor="let pharmacy of allselected[0].pharmacies; trackBy: trackByFn" class="slide" style="width: 290px !important;">
      <div class="head">
        <h2 class="heading">{{ pharmacy.DrugName }}</h2>
        <img src="{{ pharmacy.LogoLink }}" alt="logo-icon" />
      </div>
      <div class="dosage">
        <span>{{ pharmacy.Dosage }}</span>
        <span class="dose-quantity">{{ pharmacy.Quantity }} {{pharmacy.Type}}</span>
      </div>
      <div class="save">
        <span class="strike" *ngIf="pharmacy.Savings_Percent">${{ pharmacy.RetailPrice }}</span>
        <div>
          <span>${{ pharmacy.Price }}</span>
          <span class="save-percent" *ngIf="pharmacy.Savings_Percent">Save {{ pharmacy.Savings_Percent }}%</span>
        </div>
      </div>
      <span class="free-coupon" (click)="showDiscountcard(pharmacy, index)">Get Free Coupon</span>
    </div> 
  </ngx-slick-carousel>
</section>
<!-- <section class="littelAngelWelcomeWd">
  <div class="littelAngelWelcome">
    <h2>Welcome to RxHacker</h2>
    <p>The free and easy way to save on your prescription drugs. Our discount card can help you save up to 80% on the cost of your medications. We partner with pharmacies all across the country to bring you the best prices available. And best of all, our card is completely free!</p>
  </div>
  <div class="littelAngelWlVideo">
    <img src="../../assets/images/welcome_Rx.jpg">
  </div>
</section> -->
<section class="petPrescriptionWorks">
  <div class="PrescriptionHowWorks">
    <h2>How it works</h2>
    <p>Using our discount card is simple. Here’s how it works:</p>
  </div>
  <div class="PrescriptionHowWorksRight">
  <div class="PrescriptionWorksTxt">
    <img src="../../assets/images/medication.svg">
    <h3>Download Card</h3>
    <p>Save your NuLifeSpan Rx card to your phone wallet, photo gallery or print it out</p>
  </div>
  <div class="PrescriptionWorksTxt">
    <img src="../../assets/images/discounted.svg">
    <h3>Compare prices</h3>
    <p>Use our pricing tool to find the cheapest pharmacy for the medication you need</p>
  </div>
  <div class="PrescriptionWorksTxt">
    <img src="../../assets/images/pharmacy.svg">
    <h3>Show Pharmacist, Always!</h3>
    <p>Always present your card to your pharmacist and enjoy instant savings and cashback rewards!</p>
  </div>
  </div>
  <button class="btn" (click)="newDiscountModal()">Get Your Card</button>
  </section>
  <section class="discountCard">
    <div class="discountCardRow">
      <div class="discountCardRowLeft">
        <h2>Get your free NuLifeSpan Rx discount card today</h2>
        <p>It’s easy to start saving on your prescription drugs. Simply download our discount card today and start enjoying big savings on your medications.</p>
        <div class="walletDiv">
          <div class="discountWallet"  (click)="openpass(applegenericpassval)"  *ngIf="ios">
            <img src="../../assets/images/apple_wallet.png">
            <span>Add to Apple wallet</span>
          </div>
          <div class="discountWallet google-wall" (click)="openpass(googlegenericpassval)" *ngIf="android">
          <img src="../../assets/images/google_wallet.png">
          <span>Add to Google wallet</span>
        </div>
        </div>
        <button class="" (click)="newDiscountModal()">Download Your Free Card Now</button>
      </div>
      <div class="discountCardRowRow">
        <img src="../../assets/images/getCard.png" class="forDesktop">
        <img src="../../assets/images/getCardMob.png" class="forMobile">
      </div>
    </div>
  </section>
  <div class="showemailpopup" *ngIf="showemailpopup">
    <div class="inner">
      <h3>Share Pass</h3>
      <p>Looks like you're on Chrome for iOS. Please enter your email below to receive your Apple pass
      </p>
      <div class="email_field" style="position: relative">
        <input type="email" id="UserInputEmailcard" name="UserInputEmailcard" placeholder="Enter your E-mail" [(ngModel)]="UserInputEmailcard"
          (click)="ClearMessage($event)" (blur)="ClearMessage($event)" (keypress)="ClearMessage()"
          autocomplete="off" />
        <!-- <label for="email">Enter your E-mail</label> -->
        <div class="sendbtn" (click)="SharePassonemail()">{{Sendtext}}</div>
        <div class="loadProcess"></div>
      </div>
      <p class="error" *ngIf="UserInputEmailcarderror !=''">{{UserInputEmailcarderror}}</p>
    </div>
  </div>
  <section class="petPrescriptionBenefits">
    <div class="petPrescriptionBenefitsLeft">
      <h2>Who Can Use NuLifeSpan Rx</h2>
      <p>Use your card yourself or share with friends and family. NuLifeSpan Rx is for everyone!</p>
      <button class="mobileHidden" (click)="newDiscountModal()">Download Card</button>
    </div>
    <div class="petPrescriptionBenefitsRight">
    <div class="petPrescriptionBenefitsIcons">
      <img src="../../assets/images/family.svg">
      <div>
        <h3>Your Family</h3>
        <p>Use your card for your entire family</p>
      </div>
    </div>
    <div class="petPrescriptionBenefitsIcons">
      <img src="../../assets/images/senior.svg">
      <div>
        <h3>Seniors</h3>
        <p>Seniors that have reached their Medicare temporary limit on prescriptions</p>
      </div>
    </div>
    <div class="petPrescriptionBenefitsIcons">
      <img src="../../assets/images/uninsured.svg">
      <div>
        <h3>Underinsured/Uninsured</h3>
        <p>Individuals with limited or no prescription coverage</p>
      </div>
    </div>
    <div class="petPrescriptionBenefitsIcons">      
      <img src="../../assets/images/pets.svg">
      <div>
        <h3>Pets</h3>
        <p>Yes we really meant the entire family!</p>
      </div>
    </div>
    <button class="desktopHidden homeBtn homeBtnHome" (click)="newDiscountModal()">Download Card</button>
  </div>
  </section>
  <!-- <section class="bestPrice" id="homeNavSearch">
    <div class="bestPriceRow" id="bestPriceRowId">
      <div class="bestPriceLeft">
        <h2>Find the best prices on your prescriptions</h2>
        <p>Our pricing tool makes it easy to find the lowest prices on your medications. Simply enter the name of your drug, and we’ll show you the prices at pharmacies near you.</p>
        <nav-search></nav-search>
        <button>Find the Lowest Price</button>
      </div>
      <img src="../../assets/images/underinsured/insured_prescriptions.png">
    </div>
  </section> -->
  <!-- <section class="hero-shape-left reviewSection">
    <div class="work-section margin-221">
      <div class="columns is-vcentered">
        <div class="column reviewsRow ">
          <h2 class="customer-review-title" id="reviewHome">See what our customers are saying</h2>
          <p>Don’t just take our word for it. See what some of our satisfied customers have to say about our discount card:</p>
          <button class="mobileHidden" (click)="newDiscountModal()">Get Your Free Card Now</button>
        </div>
        <div class="column quotes-img petQuotesImg">
          <div class="customer-review-box petReviews">
            <div class="review">
  
              <ngx-slick-carousel class="review" #slickModal="slick-carousel" [config]="slideConfig">
                <div ngxSlickItem *ngFor="let slide of slides" class="slide" style="width: 290px !important;">
                  <h5 class="customer-review">{{ slide.text }}</h5>
                  <p class="review-src">{{ slide.heading }}</p>
                  
                </div>
              </ngx-slick-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="desktopHidden mobReviewBtn" (click)="newDiscountModal()">Get Your Free Card Now</button>
  </section> -->

  <!-- discount card start -->
  <div class="pharmacyPage newDiscountCardModal printView" *ngIf="newDisCardModal" id="printArea">
  <div class="discount_card"  id="print-section">
    <div class="close_search_pharmacy_popup" (click)="CloseNewCardModal()"></div>

    <div class="discount_card_parent">
      <div class="header">
        <img src="../../assets/images/logo-white-bg.png" alt="" />
        <div class="button_sec">
          <div class="print" (click)="PrintMe()" data-after="Print"></div>
          </div>
        </div>
      
      <div class="pharmacyDetail">
       
        <div class="border-bottom"></div>
        
        <div class="discountModalTxt"><h5>For use at any major retail pharmacy and save!</h5></div>
          <div class="method_salt two">
          <div class="method">
            <div>bin</div>
            <div>023518</div>
          </div>
          <div class="method">
            <div>PCN</div>
            <div>ARX</div>
          </div>
          <div class="method">
            <div>Member ID</div>
            <div>100-4542</div>
          </div>
          <div class="method">
            <div>Group</div>
            <div>{{newCardGroupNo}}</div>
          </div>
        </div>
        <p class="no-insurance pt-0">The NuLifeSpan Rx prescription discount program is free. <span class="strong-text">This is not insurance.</span></p>
        <!-- <div class="email_field" style="position: relative">
          <input type="email" id="email" name="ShareEmail" placeholder=" " [(ngModel)]="UserInputEmail"
            (click)="ClearMessage($event)" (blur)="ClearMessage($event)" (keypress)="ClearMessage()"
            autocomplete="off" />
          <label for="email">Enter your E-mail</label>
          <div class="sendbtn" (click)="ShareDiscountCard()">Send</div>
          <div class="loadProcess"></div>
        </div> -->
        <span style="color:#f19f57">{{ SendDiscountMessage }}</span>
        <!-- <div class="helpline_btn">
          <div class="helpline" (click)="PharmacyHelpLine()">
            {{ PharmacistHelpline }}
          </div>
          <div class="direction" (click)="RedirectGoogleDirection()">
            Get Directions
            <img src="../../assets/images/direction.svg" alt="" />
          </div>
        </div> -->
      </div>
    </div>
  </div>
  </div>
  <div class="clearfix"></div>

 <div class="search_pharmacy_popup pharmacyPopupZ" *ngIf="ShowDrugdetailszip">
  <div class="close_search_pharmacy_popup is-hidden-mobile" (click)="CloseDrugDetails()"></div>
  <div class="search_pharmacy_select max332">
    <div class="close_search_pharmacy_popup is-hidden-desktop" (click)="CloseDrugDetails()"></div>
    <!-- <h2>Atenolol ( Generic Tenormin )</h2> -->
    <h2>Set Your Location</h2>
    <div class="filter_box">
      <div class="lists_box PharmacyNear">
        <div>
          <label>Zipcode</label>

          <!-- <div class="filtertext">Oakland, CA 94618, USA</div> -->
          <div class="filtertext clearfix">
            <input id="getzipcode" type="tel" (keyup)="removeerror($event);" placeholder="Type zipcode" value="{{ _CurrLocation }}"
              [(ngModel)]="_UserZip"  autocomplete="off"  maxlength="5" class="padding-left-0" />
          </div>
          <!-- <i></i> -->
          <span>{{ ZipCodeMessage }}</span>
        </div>
      </div>
      <div class="autopic_location">
        <input type="checkbox" id="pick_location" (change)="GetAutoLocation($event)" />
        <label for="pick_location"><span></span>Auto pick my location</label>
      </div>
      <div class="find_button" (click)="Redirect_LoadPharmacy()">
        Submit
      </div>
    </div>
  </div>
</div>
<div class="pharmacyPage" style="height: 1px;min-height: 1px;">
<div class="discount_card" *ngIf="showcard" id="print-section">
  <div class="close_search_pharmacy_popup is-hidden-mobile" (click)="CloseDrugDetails()"></div>
  <div class="discount_card_parent">
    <div class="close_search_pharmacy_popup is-hidden-desktop" (click)="CloseDrugDetails()"></div>
    <div class="header">
      <img src="../../assets/images/logo-white-bg.png" alt="" />
      <div class="button_sec">
        <!-- <div class="sendsms">Send SMS</div> -->
        <div class="print" (click)="PrintMe()" data-after="Print"></div>
        <div class="save" (click)="SaveCard()" [class.saved]="IsSave == 'Remove'" data-after="Save">
        </div>
        <!-- <button  printTitle="MyTitle"   [useExistingCss]="true"   styleSheetFile="src\styles.scss" printSectionId="print-section" ngxPrint>print</button> -->
      </div>
    </div>
    <!-- <div class="logoarea" *ngIf="Card_Pharmacy_Logo">
      <div class="singlecare">
        <img src="../../assets/images/singlecare.svg" alt="">
      </div>
      <div class="walmart_img" *ngIf="RXS_Walmart">
        <span>Available at</span>
        <img src="http://rxhacker.23byt.es/MailSnap/wallmart.svg" alt="">
      </div>
      <div class="cvs_img" *ngIf="RXS_CVS">
        <span>For exclusive use at</span>
        <img src="http://rxhacker.23byt.es/MailSnap/cvs.svg" alt="">
      </div>
    </div> -->
    <!-- <div class="pharmacybox">
      <div class="name_quantity">
        <p>{{ Card_DrugName }}</p>
        <span>{{ Card_Quantity }} {{ Card_DrugForm }} | {{ Card_Dosage }}</span>
      </div>
      <div class="price">{{ PharmacyPrice }}</div>
    </div> -->
    <div class="pharmacyDetail">
      <div class="name">
        {{ SelectPharmacy }}
      </div>
      <div class="address">{{ PAddress2 }}</div>
      <a *ngIf="PharmacyPhone" class="number" [href]="'tel://' + PharmacyPhone">{{ PharmacyPhone }}</a>
      <div class="border-bottom"></div>
      <div class="method_salt one">
        <div class="method col-lg-6-0l">
          <div>DRUG</div>
          <div>{{ Card_DrugName }}</div>
        </div>
        <div class="method">
          <div>DOSAGE</div>
          <div>{{ Card_Dosage }}</div>
        </div>
        <div class="method">
          <div>FORM</div>
          <div [ngClass]="{'word-break-all': Card_DrugForm.length > 8}">{{ Card_DrugForm }}</div>
        </div>
      </div>
      <div [ngClass]="{'long-form': Card_DrugForm.length > 8}" class="method_salt two">
        <div class="method">
          <div>bin</div>
          <div>{{ RXBin }}</div>
        </div>
        <div class="method">
          <div>PCN</div>
          <div>{{ RXCPN }}</div>
        </div>
        <div class="method">
          <div>Member ID</div>
          <div>{{ MemberId }}</div>
        </div>
        <div class="method">
          <div>Group</div>
          <div>{{ Group_Number }}</div>
        </div>
      </div>
      <p class="no-insurance pt-0">The NuLifeSpan Rx prescription discount program is free. <span class="strong-text">This is not insurance.</span></p>
      <div class="email_field" style="position: relative">
        <input type="email" id="email" name="ShareEmail" placeholder=" " [(ngModel)]="UserInputEmail"
          (click)="ClearMessage($event)" (blur)="ClearMessage($event)" (keypress)="ClearMessage()"
          autocomplete="off" />
        <label for="email">Enter your E-mail</label>
        <div class="sendbtn" (click)="ShareDiscountCard()">Send</div>
        <div class="loadProcess"></div>
      </div>
      <span style="color:#f19f57">{{ SendDiscountMessage }}</span>
      <div class="helpline_btn">
        <div class="helpline" (click)="PharmacyHelpLine()">
          {{ PharmacistHelpline }}
        </div>
        <div class="direction" (click)="RedirectGoogleDirection()">
          Get Directions
          <img src="../../assets/images/direction.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<!-- signup modal start -->
  <!-- // carosuel section \\ -->
  <section class="hero-shape-left reviewSection home">
    <div class="work-section margin-221">
      <div class="columns is-vcentered">
        <div class="column reviewsRow">
          <!-- Best price  -->
          <h2 class="customer-review-title">What Our Customers are Saying</h2>
          <p>Don’t just take our word for it. See what some of our satisfied customers have to say about our discount card:</p>
          <button class="mobileHidden" (click)="newDiscountModal()">Download Card</button>
        </div>
        <div class="column quotes-img petQuotesImg">
          <div class="customer-review-box petReviews">
            <div class="review">  
              <ngx-slick-carousel class="review" #slickModal="slick-carousel" [config]="slideConfig">
                <div ngxSlickItem *ngFor="let slide of slides" class="slide" style="width: 290px !important;">
                  <h5 class="customer-review">{{ slide.text }}</h5>
                  <p class="review-src">{{ slide.heading }}</p>
                  <span class="review-src">{{ slide.source }}</span>
                </div>
              </ngx-slick-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="desktopHidden petReviewMob" (click)="newDiscountModal()">Download Card</button>
  </section>
  <!-- // accordian section \\ -->
<section class="accordian-section needHelp contactSecFour home-accordian" id="faqs">
  <div class="comman-width">
    <app-home-accordian></app-home-accordian>
  </div>
</section>
<!-- \\ accordian section // -->
  <!-- \\ carosuel section // -->
  <section class="bestPrice adjust" id="navSearchBar">
    <div class="bestPriceRow home">
      <div class="bestPriceLeft">
        <h2>Pets are <br/> covered also</h2>
        <p>Don't forget about your furry friends because we didn't either. Use the card for your pet as you would for yourself.</p>
        <button class="download-card" (click)="newDiscountModal()">Download Card</button>
      </div>
      <img src="../../assets/images/bestPrice.png">
    </div>
  </section>  